/** Mínimo de calificaciones reales para mostrar estrellas “activas” en el catálogo. */
export const MIN_CALIFICACIONES_REPUTACION_VISIBLE = 3;

/**
 * Promedio 0–5 y cantidad desde perfil Firestore (cuando exista el flujo de reseñas).
 * @param {Record<string, unknown> | null | undefined} perfil
 */
export function reputacionDesdePerfil(perfil) {
  const c = Math.max(0, Math.floor(Number(perfil?.rating_count) || 0));
  const sum = Number(perfil?.rating_sum) || 0;
  const avg = c > 0 ? Math.min(5, Math.max(0, sum / c)) : 0;
  return { promedio: avg, cantidad: c };
}

/** Campos a guardar en cada publicación (denormalizado). */
export function snapshotReputacionParaProducto(perfil) {
  const { promedio, cantidad } = reputacionDesdePerfil(perfil);
  return {
    vendedor_reputacion_avg: Math.round(promedio * 10) / 10,
    vendedor_reputacion_cuenta: cantidad,
  };
}

export function reputacionListaActiva(cantidad) {
  return Number(cantidad) >= MIN_CALIFICACIONES_REPUTACION_VISIBLE;
}

/**
 * Textos para la tarjeta "Rating" en perfil (promedio real + aclaración de umbral en catálogo).
 * @param {Record<string, unknown> | null | undefined} perfil
 */
export function perfilRatingTarjetaCopy(perfil) {
  const { promedio, cantidad } = reputacionDesdePerfil(perfil);
  if (cantidad <= 0) {
    return {
      ratingDisplay: '—',
      ratingSubline: 'Sin reseñas: cuando un comprador te califique acá verás el promedio.',
    };
  }
  const ratingDisplay = (Math.round(promedio * 10) / 10).toLocaleString('es-AR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  const ratingSubline =
    cantidad < MIN_CALIFICACIONES_REPUTACION_VISIBLE
      ? `${cantidad} ${cantidad === 1 ? 'reseña' : 'reseñas'} · en el catálogo las estrellas “completas” aparecen con ${MIN_CALIFICACIONES_REPUTACION_VISIBLE} o más.`
      : `${cantidad} ${cantidad === 1 ? 'reseña' : 'reseñas'}`;
  return { ratingDisplay, ratingSubline };
}
